/**
 * Thin { get, post } wrapper around the shared axios client, matching the
 * shape @neuro/chat-adapter's plugin helper expects (BackendToolApiClient /
 * RagApiClient), and reused by the overlay's non-adapter REST calls (e.g.
 * canonical agent lookup, room creation for "Continue in Chat"). The shared
 * client's response interceptor already unwraps the backend's
 * `{ ok, data }` envelope into `res.data`.
 */
import client from '../../api/client';

export function buildAssistantApiClient() {
  return {
    get: <T,>(path: string) => client.get<T>(path).then((r) => r.data as T),
    post: <T,>(path: string, data?: unknown) => client.post<T>(path, data).then((r) => r.data as T),
  };
}
